module.exports = __webpack_public_path__ + "img/x4.cd61a4ed.jpg";